import Link from 'gatsby-link';
import React, { Component } from 'react';
import { Parallax } from 'react-parallax';
import Zoom from 'react-reveal/Zoom';
import Slider from 'react-slick';
import { Button, Container, Divider, Header, List, Responsive } from 'semantic-ui-react';
import MobileSubpageSideBar from '../components/MobileSubpageSideBar';
import img2 from '../assets/img/slideshow/mpost14.jpg';
import img3 from '../assets/img/slideshow/mpost25.jpg';
import img9 from '../assets/img/slideshow/mpost28.jpg';
import img4 from '../assets/img/slideshow/mpost3.jpg';
import img5 from '../assets/img/slideshow/mpost35.jpg';
import img6 from '../assets/img/slideshow/mpost37.jpg';
import img7 from '../assets/img/slideshow/mpost44.jpg';
import img8 from '../assets/img/slideshow/mpost52.jpg';
import img1 from '../assets/img/slideshow/mpost53.jpg';
import img10 from '../assets/img/slideshow/mpost64.jpg';
import img11 from '../assets/img/slideshow/mpost77.jpg';
import BasicContainer from '../components/BasicContainer';
import Clients from '../components/Clients';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import GradientContainer from '../components/GradientContainer';
import HomeDesktopHeader from '../components/HomeDesktopHeader';
import HomeMobileHeader from '../components/HomeMobileHeader';
import InvertedContainer from '../components/InvertedContainer';
import Works from '../components/Works';

//Slideshow
// import IMAGE1 from '../assets/img/1.jpeg'
// import IMAGE2 from '../assets/img/2.jpeg'
// import IMAGE3 from '../assets/img/3.jpeg'
const shuffle = require('knuth-shuffle').knuthShuffle;
const slideshow = {
  dots: false,
  infinite: true,
  speed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  fade: true,
  draggable: true,
  autoplaySpeed: 10000,
  swipe: true
};

const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11
]
const uuidv4 = require('uuid/v4');
const services = ['Documentaries', 'Wedding Films', 'Highlight Films', 'Trailer', 'Photo Coloring and Layout'];

// const clients = [
//   'https://cdn.svgporn.com/logos/admob.svg',
//   'https://cdn.svgporn.com/logos/akka.svg',
//   'https://cdn.svgporn.com/logos/processwire.svg',
//   'https://cdn.svgporn.com/logos/packer.svg',
//   'https://cdn.svgporn.com/logos/fabric_io.svg',
//   'https://cdn.svgporn.com/logos/dropbox.svg',
//   'https://cdn.svgporn.com/logos/drift.svg',
//   'https://cdn.svgporn.com/logos/glint.svg',
//   'https://cdn.svgporn.com/logos/google-adsense.svg',
//   'https://cdn.svgporn.com/logos/google-analytics.svg',
//   'https://cdn.svgporn.com/logos/ibm.svg',
//   'https://cdn.svgporn.com/logos/launchrock.svg',
//   'https://cdn.svgporn.com/logos/udemy.svg',
//   'https://cdn.svgporn.com/logos/woocommerce.svg',
//   'https://cdn.svgporn.com/logos/aurous.svg',
//   'https://cdn.svgporn.com/logos/instagram.svg'
// ]

const randomHeaderText = [
  {
    detail: 'Welcome to Mayad Post-Production House, your trusted co-author and editor in imagining and crafting a classic memento that will last for a lifetime - a wedding film that shares the anthology of your love to the world.',
    title: 'Imagining and Crafting a Classic Memento'
  },
  {
    detail: 'We help wedding filmmakers from around the world manage their post-production needs.',
    title: (<div><span>Welcome to</span><br /><span>MPOST</span></div>)
  },
]

const subheaderText = [
  'We – the Mayad Post-Production House (MPOST) – are the secret powerhouse of the internationally-recognized Mayad Studios. We are a force of globally-competitive creative champions. And as a recognized authority in the art of editing cinematic wedding films, MPOST renders expertly post-production services internationally – from neighboring countries and across different continents.',
  'Allow us to take an active part in your creative adventure. Allow us to be the secret of your success, and together, we will make the epic happen… the Mayad way.'
]

const serviceText = [
  'We give filmmakers the gift of time to grow their craft and business through our post-production services.',
  'As post-production artists, we help our clients produce more films - giving them the luxury of making and nourishing lasting relationships to their expanding clientele.'
]

const featuredText = [
  'Your wedding film is not just a masterpiece from us. It’s the symbol of a wonderful collaboration between you and us – your romantic memoir and our gift in cinematic storytelling and editing. This is the reason why we call this piece of art ours.'
]
class HeaderSliderItem extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Container fluid className="mpost-header--home">
            <Parallax
              bgImage={this.props.src}
              bgImageAlt=""
              strength={300}
              bgClassName="mpost-header--home"
            >
              <div className="backround-overlay--dim">
                <div className="mpost-header-spacer" />
                <Container className="mpost-identity">
                  <Header className="mpost-header--jumbo" content={this.props.headerTitleText} inverted />
                  <p className="mpost-header--text">{this.props.headerText}</p>
                </Container>
              </div>
            </Parallax>
          </Container>
        </Responsive>
        <Responsive {...Responsive.onlyMobile}>
          <Container fluid className="mpost-header--home mobile">
            <Parallax
              bgImage={this.props.src}
              bgImageAlt=""
              strength={300}
              bgClassName="mpost-header--home"
            >
              <div className="backround-overlay--dim">
                <div className="mpost-header-spacer mobile" />
                <Container className="mpost-identity">
                  <Header className="mpost-header--jumbo mobile" content={this.props.headerTitleText} inverted />
                  <p className="mpost-header--text mobile">{this.props.headerText}</p>
                </Container>
              </div>
            </Parallax>
          </Container>
        </Responsive>
      </div>
    )
  }
}

class HomeContent extends Component {
  constructor(props){
    super(props)
    this.state = {
      visible:false
    }
  }

  openMenu = (state) => {
    this.setState({ visible: state })
    console.log(state)
  }

  componentDidMount() {
    setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 1000);
  }

  render() {
    const {visible} = this.state
    return (
      <div>
        <MobileSubpageSideBar menuOpen={this.openMenu} visible={visible}>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <HomeDesktopHeader />
          <Slider {...slideshow}>
            {Object.keys(images).map(i => {
              let text = shuffle(randomHeaderText)[0];
              // console.log(text)
              return (
                <div key={uuidv4()}>
                  <HeaderSliderItem src={images[i]} headerText={text.detail} headerTitleText={text.title} />
                </div>
              )
            })}
          </Slider>

          <GradientContainer>
            <Zoom>
              <div>
                {subheaderText.map(i => (
                  <p key={uuidv4()} className="mpost-p inverted">{i}</p>
                ))}
              </div>
            </Zoom>
          </GradientContainer>

          <BasicContainer>
            <Zoom>
              <Header content="Services" className="mpost-header--huge" textAlign="center" />
              <div className="mpost-header--divider" />
              <Container textAlign="center">
                <List relaxed divided horizontal size="huge">
                  {services.map(service => (
                    <List.Item key={uuidv4()}>
                      <List.Content>
                        <List.Header as="h4" className="mpost-list--service">{service}</List.Header>
                      </List.Content>
                    </List.Item>
                  ))}
                </List>
                {serviceText.map(i => (
                  <p key={uuidv4()} className="mpost-p">
                    {i}
                  </p>
                ))}
                <Button as={Link} to="services/" content="Learn More" className="mpost-button">
                </Button>
              </Container>
            </Zoom>
          </BasicContainer>
          <InvertedContainer textAlign="center">
            <Zoom>
              <Header inverted content="Featured Projects" className="mpost-header--huge inverted" textAlign="center" />
              <div className="mpost-header--divider" />
              {featuredText.map(i => (
                <p key={uuidv4()} className="mpost-p inverted">{i}</p>
              ))}
            </Zoom>
          </InvertedContainer>
          <Divider style={{ marginTop: 0, height: 0, backgroundColor: 'transparent', border: 0 }} clearing />
          <Works />
          <Divider style={{ marginTop: 0, height: 1, backgroundColor: 'transparent', border: 0 }} clearing />
          <div style={{ backgroundColor: '#F2F2F2' }}>
            <Clients testimony={true} />
            <ContactSection />
            <Footer />
          </div>
        </Responsive>
        {/* Mobile */}
        <Responsive {...Responsive.onlyMobile}>
          <HomeMobileHeader menuOpen={this.openMenu} />
          <Slider {...slideshow}>
            {Object.keys(images).map(i => {
              let text = shuffle(randomHeaderText)[0];
              return (
                <div key={uuidv4()}>
                  <HeaderSliderItem src={images[i]} headerText={text.detail} headerTitleText={text.title} />
                </div>
              )
            })}
          </Slider>
          <GradientContainer>
            <Zoom>
              <div>
                {subheaderText.map(i => (
                  <p key={uuidv4()} className="mpost-p mobile inverted">{i}</p>
                ))}
              </div>
            </Zoom>
          </GradientContainer>
          <BasicContainer>
            <div>
              <Zoom>
                <Header content="Services" className="mpost-header--huge mobile" textAlign="center" />
                <div className="mpost-header--divider" />
              </Zoom>
              <Zoom>
                <List style={{ textAlign: 'center', fontSize: '1.3rem' }} relaxed="very" items={services} />
              </Zoom>
              <Divider />
              {serviceText.map(i => (
                <Zoom key={uuidv4()}>
                  <p className="mpost-p mobile">
                    {i}
                  </p>
                </Zoom>
              ))}
              <Container textAlign="center">
                <Button as={Link} to="services/" content="Learn More" className="mpost-button" />
              </Container>
            </div>
          </BasicContainer>
          <InvertedContainer textAlign="center">
            <Zoom>
              <Header inverted content="Featured Projects" className="mpost-header--huge inverted mobile" textAlign="center" />
              <div className="mpost-header--divider" />
            </Zoom>

            {featuredText.map(i => (
              <Zoom key={uuidv4()}>
                <p className="mpost-p mobile inverted">{i}</p>
              </Zoom>
            ))}

          </InvertedContainer>
          <Works />
          <div style={{ backgroundColor: '#F2F2F2' }}>
            <Clients testimony={true} />
            <ContactSection />
            <Footer />
          </div>
        </Responsive>
        </MobileSubpageSideBar>
      </div>
    )
  }
}

const IndexPage = () => (
  <HomeContent />
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js